'use strict';

export function init() {
    document.querySelectorAll('.nav-popup[popover]').forEach(popup => {
        popup.addEventListener('toggle', event => {
            const isOpen = event.newState === 'open';
            document.body.classList.toggle('desktop-nav-open', isOpen);

            const trigger = document.querySelector(`[popovertarget="${popup.id}"].desktop-nav__item`);
            if (trigger) trigger.setAttribute('aria-expanded', String(isOpen));
        });
    });
}

export default { init };
